<div *ngIf="loader " class="align-items-center d-flex flex-column justify-content-center position-absolute light-trans-bg z-1"
  style="top: 150px; bottom: 0; right: 0; left: 0;">
  <div class="lds-ring d-inline-block position-relative sm-hw">
      <div class="d-block sm-hw position-absolute m-1 rounded-circle"></div>
      <div class="d-block sm-hw position-absolute m-1 rounded-circle"></div>
      <div class="d-block sm-hw position-absolute m-1 rounded-circle"></div>
  </div>
</div> <!-- | async-->

<!-- Loading icon -->